module.exports = "/_next/static/images/device-dad201118bb0b6a4265432b9633b31ca.svg";